// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".location-selector{padding:1em 1em 0 0}@media print{.location-selector{background-color:#f5f5f5;padding:1em;-webkit-print-color-adjust:exact!important}}.location-selector .alert{box-shadow:0 2px 4px 0 rgba(0,0,0,.1);cursor:pointer;font-size:18px;margin-bottom:0}.location-selector .print{color:#414a51;cursor:pointer;float:right;font-size:.75rem;margin-top:20px}.location-selector .print .fa-print{font-weight:900;margin-right:10px}", ""]);
// Exports
module.exports = exports;
